module.exports = __webpack_public_path__ + "media/src/assets/images/content/one-attempt-aabd708b8ecafc66f3d4f2657c2463d7.png";